<template>
  <div class="main-content-cols" v-loading="loading">
    <side-menu
      v-if="showSideMenu"
      :menus="menus"
      :actived="actived"
      @change="deviceChange"
    >
    </side-menu>

    <div class="main-content-cols__body">
      <dev-chart
        ref="devChart"
        v-show="showType === 'preview'"
        :colors="colors"
        :data="data"
        :cates="cates"
        :devs="devices"
        :group-type="groupType"
        :actived="actived"
      ></dev-chart>

      <slot :visible="showType === 'data'"></slot>
    </div>
  </div>
</template>

<script>
import colors from '@/utlis/colors'
import DevChart from './dev'
import SideMenu from './SideMenu'

export default {
  components: { SideMenu, DevChart },
  props: {
    showType: String,
    groupType: String,
    loading: Boolean,
    data: Array
  },
  data() {
    return {
      sumLoading: false,
      actived: 0,
      menus: [],
      colors: colors
    }
  },
  computed: {
    devices() {
      return this.data && this.data[0] ? this.data[0].devices : this.teles
    },
    dev() {
      return this.devices[this.actived]
    },
    cates() {
      return this.categories
    },
    showSideMenu() {
      return this.groupType === 'device' ? this.devices.length > 1 : true
    }
  },
  mounted() {
    this.setMenus(this.data, this.teles, this.groupType)
  },
  methods: {
    setMenus(data, teles, type) {
      const isShowDevice = type === 'device'
      let ms = isShowDevice
        ? data && data[0]
          ? data[0].devices
          : teles
        : this.cates

      let menus = ms.map((m, idx) => ({
        name: m.name,
        count: 0,
        color: isShowDevice ? '' : this.colors[idx]
      }))

      data.forEach(d => {
        d.devices.forEach(dev => {
          dev.categories.forEach(c => {
            const idx = isShowDevice
              ? ms.findIndex(o => o.id === dev.id)
              : ms.findIndex(o => o.name === c.name)
            menus[idx].count += c.qty
          })
        })
      })
      this.menus = menus
      this.deviceChange(0)
    },
    deviceChange(index) {
      this.actived = index
      // this.$refs.devChart.checkChange(-1)
      this.$emit('actived', index)
    }
  },
  watch: {
    data(d) {
      this.setMenus(d, this.teles, this.groupType)
    },
    groupType(type) {
      this.setMenus(this.data, this.teles, type)
    }
  }
}
</script>

<style lang="scss">
.page-report {
  .main-content-cols__body {
    background-color: #ebeef5;
    overflow-y: auto;
    .el-table {
      background-color: #ebeef5;
    }
  }
  .chart-container {
    background-color: #fff;
  }
  .report-expand {
    overflow: auto;
    padding-top: 12px;
    // margin-top: 20px;
  }
}
</style>
